/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, position: NonNullable<unknown> }} Agenda_Journey_Suggestion_LinkInputs */



/**
* | output |
* | --- |
* | "Link to {name} step {position}" |
*
* @param {Agenda_Journey_Suggestion_LinkInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_journey_suggestion_link = /** @type {((inputs: Agenda_Journey_Suggestion_LinkInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Journey_Suggestion_LinkInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Koppel aan ${i?.name} stap ${i?.position}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Associer à ${i?.name} étape ${i?.position}`)
	return /** @type {LocalizedString} */ (`Link to ${i?.name} step ${i?.position}`)
});